<template>
    <div>
       <img src="../../assets/images/appOrder.jpg" alt="">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
img{
    width: 100%;
}
</style>